import { NomenclatureItemFindDto, type NomenclatureItemFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-item-find.dto';
import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { BusinessDtoKeysEnum } from '@zaoblako/shared/modules/business/enum/business-dto-keys.enum';

import * as yup from 'yup';

/** Deal order response body */
export interface DealOrderFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;

  // Tech columns
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;
  /** Soft deletion date and time. The order will be permanently deleted six months after this date. */
  deleted?: Date;
  /** The user who created this order */
  createdBy?: UserFindInterface;

  // Data columns
  /** Nomenclature item for order */
  nomenclatureItem: NomenclatureItemFindInterface;
  /** Price of nomenclature. Equals {@link NomenclatureFindInterface.price} by default, but may differ from it. */
  price: number;
  /** Number of nomenclature items. */
  count: number;
  /**
   * Total order amount. The product of fields {@link DealOrderFindInterface.price} and
   * {@link DealOrderFindInterface.count}.
   * It's automatically calculated by the database and is not edited.
   */
  amount: number;
}

/** Deal order response body - DTO schema */
export const DealOrderFindDto = SerdeDtoClass.create<DealOrderFindInterface>(BusinessDtoKeysEnum.DEAL_ORDER_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  createdBy: {
    label: 'Автор',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  nomenclatureItem: {
    label: 'Номенклатура',
    nested: NomenclatureItemFindDto,
    serializer: (_, nested) => nested,
  },
  price: {
    label: 'Цена',
    serializer: yup.number(),
  },
  count: {
    label: 'Количество',
    serializer: yup.number(),
  },
  amount: {
    label: 'Сумма',
    serializer: yup.number(),
  },
});
